// ** Redux Imports
/* eslint-disable */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { vendor } from "../../../../api/Api";

export const getAllVendor = createAsyncThunk(
  "appVendor/getAllVendor",
  async (query) => {
    try {
      return vendor.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getVendor = createAsyncThunk("appVendor/getVendor", async (id) => {
  try {
    return vendor.getVendor(id);
  } catch (error) {
    console.error(error);
  }
});

export const commissionActive = createAsyncThunk(
  "appVendor/commissionActive",
  async (value) => {
    return vendor.active(value);
  }
);

export const addVendor = createAsyncThunk(
  "appVendor/addVendor",
  async (values) => {
    try {
      return vendor.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editVendor = createAsyncThunk(
  "appVendor/editVendor",
  async (values) => {
    return vendor.edit(values);
  }
);

export const deleteVendor = createAsyncThunk(
  "appVendor/deleteVendor",
  async (id) => {
    return vendor.remove(id);
  }
);

export const appVendorSlice = createSlice({
  name: "appVendor",
  initialState: {
    vendor: [],
    vendorFetch: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllVendor.fulfilled, (state, action) => {
      state.metaData = action.payload?.data?.metaData;
      state.vendor = action.payload?.data?.data;
      state.vendorFetch = true;
    });
  },
});

export default appVendorSlice.reducer;
